module.exports = {
  titleCardOptions: {
    title: '需求描述',
    showMore: false,
    isSwitch: false
  },
  resultDetails: [
    {
      title: '',
      contents: [
        `一种抗静电石墨烯乳胶浆料，其特征在于，所述抗静电石墨烯乳胶浆料包括如下重量份数的组分：天然乳胶70～90份、硫化剂2～5份、抗静电剂2～5份和功能化石墨烯2～8份；所述功能化石墨烯包括如下质量百分含量的的原料组分：氧化石墨烯8～15％、碱性化合物2～7％、十八烷基胺5～10％和还原剂70～85％。
         本发明提供一种抗静电石墨烯乳胶浆料及其工艺和应用。抗静电石墨烯乳胶浆料包括如下重量份数的组分：天然乳胶70～90份、硫化剂2～5份、抗静电
         剂2～5份和功能化石墨烯2～8份；功能化石墨烯包括如下质量百分含量的原料组分：氧化石墨烯8～15％、碱性化合物2～7％、十八烷基胺5～10％和还原剂70～85％。制备抗静电石墨烯乳胶浆料的工艺如下：将抗静电剂、硫化剂、水以及任选的促进剂和抗氧剂混合均匀，得到混合物A；然后将混合物A和功能化石墨烯混合均匀，得到混合物B；最后
         将混合物B与天然乳胶混合均匀，得到抗静电石墨烯乳胶浆料。本发明提供的抗静电石墨烯乳胶浆料具有较好的抗静电性，适用于制备靠垫或床垫。`
      ]
    }
  ]
}